<div>
	<button mat-icon-button class="icon-button" (click)="onClick()">
		<mat-icon fontIcon="{{ params.icon }}" />
	</button>
</div>
